import React, { useState } from "react";
import { Form, Input, Row, Col, Button } from "antd";
import { toast } from "react-toastify";
// import { postRequest } from "../../api/http";
import userServiceApi from "../../api/userServiceApi";
// import { LoadingView } from "../common";
import Logo from "../../../src/assets/images/PoweredNew.png";
import leftArrow from "../../../src/assets/images/LeftArrow.svg";
import { useNavigate } from "react-router-dom";
import "./ChangePassword.scss";

export default function ForgotPasswordForm() {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const onFinish = async (values) => {
    const payload = {
      ...values,
      userRole: 'SUPER_ADMIN'
    }
    setLoading(true);
    try {
      const response = await fetch(userServiceApi.forgotPassword(), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });
      const data = response.status === 200 ? await response.text() : await response.json();

      console.log("response.status", response.status);

      if (response.status === 200) {
        toast.success("Reset link has been sent to your mail");
        navigate("/SuperAdmin");
      } else if (response.status === 400) {
        // Try regex match first
        const match = data.message?.match(/\{"errors":\[.*\]\}/);
        if (match) {
          const parsed = JSON.parse(match[0]);
          if (parsed.errors && Array.isArray(parsed.errors) && parsed.errors.length > 0) {
            toast.error(parsed.errors[0].message);
          }
        } else if (data.error) {
          // Fallback: show "error" field if regex didn’t match
          toast.error(data.errorName || data.error);
        }
        else if(data?.message) {
          toast.error(data.message)
        }
        else {
          toast.error("Invalid request. Please check your details and try again.");
        }
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error(error.message || "Something went wrong, please try again.");
    } finally {
      setLoading(false);
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.error("Failed:", errorInfo);
  };

  return (
    <div className="changepassword-page">
      <div className="header-left" onClick={() => navigate("/SuperAdmin")}>
        <img src={leftArrow} alt="back-button" />
        <p>Reset password</p>
      </div>

      <div className=" custom">
        <div className="forgotPassword">
          <Form
            form={form}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete="off"
            layout="vertical"
          >
            {/* <div
            style={{ color: "black", fontSize: "18px" }}
            className="changePwdHeading"
          >
            Change Password
          </div> */}
            <div className="forgotPasswordForm">
              <div className="formRow">
                <div className="formCol">
                  <Form.Item
                    label="Email"
                    name="email"
                    normalize={(value) => value?.trim()}
                    rules={[{ required: true, message: "Email is required" }]}
                  >
                    <Input placeholder="Email" />
                  </Form.Item>
                </div>
                <div className="formCol">
                  <div className="">
                    <Button
                      className="clear-btn"
                      onClick={() => {
                        navigate("/SuperAdmin");
                      }}
                    >
                      Cancel
                    </Button>
                    <Button className="sendBtn redBtn" htmlType="submit">
                      Request Reset Link
                    </Button>
                  </div>
                </div>
                <div className="formCol"></div>
              </div>
            </div>

          </Form>
        </div>
        <div className="footerlogo">
          <img
            style={{ cursor: "pointer", width: "100px", marginTop: "15px" }}
            src={Logo}
            alt=""
          />
        </div>
      </div>
    </div>
  );
}
